function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import * as React from 'react';
import SpzaComponent from '@shared/components/spzaComponent';
import Ribbon from '@shared/components/ribbon';
import CommonTile from './commonTile';
export class PopularApps extends SpzaComponent {
    renderImpl() {
        const { popularAppsTitle, ribbonPopularApps, ribbonKey } = this.props;
        return /*#__PURE__*/ _jsx("div", {
            className: "indFeaturedContainer",
            children: /*#__PURE__*/ _jsx(Ribbon, {
                title: popularAppsTitle,
                children: ribbonPopularApps.map((offer, index)=>/*#__PURE__*/ _createElement(CommonTile, _object_spread_props(_object_spread({}, offer), {
                        item: offer,
                        tileIndex: index,
                        totalTiles: popularAppsTitle.length,
                        key: index,
                        ribbonKey: ribbonKey
                    })))
            })
        });
    }
}
